import { CitizenshipFormVM } from 'mutation/view-models/registration-citizenship';
import { DatiAggiuntiviSide } from 'shell/models/act-category-list';

export const transformNewCitizenship = (data: DatiAggiuntiviSide): CitizenshipFormVM => {
  return {
    idMotivoVariazioneCittadinanza: data.statoCivile?.idMotivoVariazioneCittadinanza,
  };
};
